import React from "react";
import PageLayout from "../../components/PageLayout";
import "./style.scss";

export default function PrivacyModel() {
  return (
    <div className="policyes">
      <PageLayout>
        <div className="container">
          <h2 className="titletwo">
            <span>Paths</span> Privacy Model
          </h2>

          <ul className="list">
            <li>
              We encrypt nearly everything, ensuring that humans cannot read the
              data stored on our platform.
            </li>
            <li>
              You retain full ownership of your likeness, thoughts, information,
              content, and creations on Paths. At any time, you have the ability
              to delete everything you’ve stored because it belongs to you, and
              we’re not holding it hostage.
            </li>
            <li>
              You can set your account to Private, requiring others to request
              access to follow your feeds, or choose Public, making your content
              open and accessible without managing requests.
            </li>
            <li>
              WIPIWYG (What Is Posted Is What You Get): Posts from friends you
              follow in your feeds are displayed either chronologically or
              sorted by their last edit date. On the Tandem Timeline™, posts are
              strictly chronological. Content is filtered by your viewing
              preferences, which only you control, or by the audience privacy
              settings applied by the content creator. If you change your mind,
              you can always choose to hide or delete your content later.
            </li>
            <li>
              The content of your entries and comments remains exactly as you
              submitted it, unless you choose to edit it yourself.
            </li>
            <li>
              You have full control over the privacy level of your entries,
              whether as public posts or private logs.
            </li>
            <li>
              We will never sell your personal information to anyone. We don’t
              scrub, scrape, or scan your submissions. Your identity is secure
              here—nothing is connected to or extracted from your content.
            </li>
            <li>
              We do not use biometrics (such as facial recognition,
              fingerprints, or voice data), ensuring that unchangeable aspects
              of your identity are never tied to our software, database, or
              business.
            </li>
            <li>
              You can easily delete your account and all associated data
              directly through the app without needing to contact us.
            </li>
            <li>
              It’s simple: we don’t automatically access your camera or
              microphone. We also don’t secretly use your Bluetooth connection.
              Control of audio and video access is entirely managed through your
              device’s operating system.
            </li>
          </ul>
        </div>
      </PageLayout>
    </div>
  );
}
